import { QueryParam } from './../../../../../../modules/private/models/query-param';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { UserConfig, USER_CONFIG } from '@core/modules/user/user.config';
import { Observable } from 'rxjs';
import { DeviceUser } from '@core/models/device-user';
import { CheckSerialDTO } from '../types/check-serial-dto.type';

type CheckSerialQueryParams = {
  passphrase?: string;
};

@Injectable({
  providedIn: 'any'
})
export class MyDeviceFormRemote {
  constructor(private http: HttpClient, @Inject(USER_CONFIG) private config: UserConfig) {}

  checkSerial({
    serial,
    passphrase
  }: {
    serial: string;
    passphrase?: string;
  }): Observable<CheckSerialDTO> {
    const queryParam: CheckSerialQueryParams = {};

    if (passphrase !== undefined && passphrase !== null) {
      queryParam.passphrase = passphrase;
    }

    return this.http.get<CheckSerialDTO>(
      this.config.REMOTE.CHECK_SERIAL.replace('{serial}', serial),
      {
        params: queryParam
      }
    );
  }

  unlinkSerial(userId: number, device: DeviceUser): Observable<any> {
    const url = this.config.REMOTE.UNLINK_SERIAL.replace('{userId}', userId.toString())
      .replace('{serial}', device.serialnumber_id.toString())
      .replace('{deviceId}', device.id!.toString());
    return this.http.delete(url);
  }
}
